import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS, IMAGES } from "@/lib/data";
import { IDS } from "@/lib/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={IDS.footer}
      className="relative bg-[#1B1B1B] text-[#F3EAD9] overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="border-b border-white/10 pb-14 mb-10">
          <p className="eyebrow text-[#C89B3C] mb-6">— Let's meet</p>
          <h3 className="font-display text-4xl md:text-6xl lg:text-7xl leading-[0.98]">
            Ready to feel a little<br />
            <span className="italic text-[#C89B3C]">more like yourself?</span>
          </h3>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/book" className="btn-gold">
              <span>Book Appointment</span>
            </Link>
            <a href={BUSINESS.phoneHref} className="btn-ghost">
              <Phone size={14} /> <span>Call the salon</span>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <p className="eyebrow text-white/50 mb-4">Studio</p>
            <div className="flex items-center gap-3 mb-3">
              <span className="w-12 h-12 rounded-full overflow-hidden bg-white shrink-0">
                <img src={IMAGES.logo} alt="Good Looks logo" className="w-full h-full object-cover" />
              </span>
              <p className="font-display text-2xl leading-tight">Good Looks</p>
            </div>
            <p className="text-white/60 text-sm mt-2 leading-relaxed">
              {BUSINESS.tagline}
            </p>
          </div>

          <div>
            <p className="eyebrow text-white/50 mb-4">Visit</p>
            <p className="text-white/85 text-sm leading-relaxed flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-[#C89B3C]" />
              <span>
                {BUSINESS.address.line1}<br />
                {BUSINESS.address.line2}
              </span>
            </p>
          </div>

          <div>
            <p className="eyebrow text-white/50 mb-4">Reach us</p>
            <a href={BUSINESS.phoneHref} className="block text-white/85 text-sm hover:text-[#C89B3C] transition-colors">
              <Phone size={14} className="inline mr-2 text-[#C89B3C]" />
              {BUSINESS.phone}
            </a>
            <a href={`mailto:${BUSINESS.email}`} className="block text-white/85 text-sm mt-2 hover:text-[#C89B3C] transition-colors">
              <Mail size={14} className="inline mr-2 text-[#C89B3C]" />
              {BUSINESS.email}
            </a>
          </div>

          <div>
            <p className="eyebrow text-white/50 mb-4">Follow</p>
            <div className="flex gap-3">
              <a
                href={BUSINESS.social.instagram}
                aria-label="Instagram"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#C89B3C] hover:border-[#C89B3C] hover:text-[#1B1B1B] transition-all"
              >
                <Instagram size={16} />
              </a>
              <a
                href={BUSINESS.social.facebook}
                aria-label="Facebook"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#C89B3C] hover:border-[#C89B3C] hover:text-[#1B1B1B] transition-all"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-10 mt-14 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p className="italic">Placeholder imagery — replace with in-salon photography before launch.</p>
        </div>
      </div>

      <div className="pointer-events-none select-none absolute -bottom-16 left-0 right-0 text-center leading-none">
        <span className="font-display text-[26vw] md:text-[18vw] tracking-tight text-white/[0.04]">
          Good Looks
        </span>
      </div>
    </footer>
  );
}
